import {z} from 'zod'
import {BoolString} from './zod'

const appParamsSchema = z.object({
  source: z.string().nullish(),
  text: z.string().nullish(),
  target: z.string().nullish(),
  style: z
    .enum(['Faithful', 'Fluid', 'Creative'] as const)
    .nullish()
    .catch(undefined),
  contextualInfo: z.string().nullish(),
  contextualInfoOriginal: z.string().nullish(),
  sourceApp: z.string().nullish().catch(undefined)
})

export type AppParams = z.infer<typeof appParamsSchema>

const websiteParamsSchema = z.object({
  noRedirect: BoolString,
  lng: z.string().nullish()
})

const searchParamsSchema = z.object({
  ...appParamsSchema.shape,
  ...websiteParamsSchema.shape
})

export const getWebsiteSearchParams = (search: string) => {
  const searchParams = new URLSearchParams(search)

  return websiteParamsSchema.parse({
    noRedirect: searchParams.get('noRedirect'),
    lng: searchParams.get('lng')
  })
}

export const getAppSearchParams = (search?: string) => {
  const searchParams = new URLSearchParams(search)

  return appParamsSchema.parse({
    source: searchParams.get('source'),
    text: searchParams.get('text'),
    target: searchParams.get('target'),
    style: searchParams.get('style'),
    contextualInfo: searchParams.get('c'),
    contextualInfoOriginal: searchParams.get('co'),
    sourceApp: searchParams.get('sourceApp')
  })
}

export const getSearchParams = (search: string) => {
  return searchParamsSchema.parse({
    ...getWebsiteSearchParams(search),
    ...getAppSearchParams(search)
  })
}

export const getSearchStringWithoutParams = (search: string, paramsToRemove: string[]) => {
  const searchParams = new URLSearchParams(search)
  paramsToRemove.forEach(param => searchParams.delete(param))
  const searchString = searchParams.toString()
  return searchString ? `?${searchString}` : ''
}
